<template>
  <div class="container-fluid mt-4 SlimTDs">
    <b-row class="mb-3 pb-1 border-bottom">
      <b-col>
        <span :class="`size-${ButtonSize}`">Şifre Değiştir</span>
      </b-col>

      <b-col cols="auto" class="text-right">
        <b-btn class="mr-3" type="button" variant="danger" to="/Settings" :size="ButtonSize">
          <i class="material-icons mifix">arrow_back</i>
          <span class="ml-1">Ayarlar</span>
        </b-btn>
      </b-col>
    </b-row>

    <b-alert show variant="info">Kullanıcı: {{ User.Username }}</b-alert>

    <form @submit.prevent="ChangePassword()" id="ChangePasswordForm">
      <input
        type="text"
        name="username"
        id="username"
        tabindex="-1"
        style="position:fixed; top:-100px;"
      />

      <input
        type="password"
        name="password"
        id="password"
        tabindex="-1"
        style="position:fixed; top:-100px;"
      />

      <b-form-group class="formgroup" label="Şuanki Şifre">
        <b-form-input
          type="password"
          pattern="[0-9]*"
          inputmode="numeric"
          @focus="Focused('OldPassword', 'ack1', 'ChangePasswordForm');"
          id="ack1"
          v-model="OldPassword"
          @keypress.enter.prevent="ChangePassword()"
        ></b-form-input>
      </b-form-group>

      <b-form-group class="formgroup" label="Yeni Şifre">
        <b-form-input
          type="password"
          pattern="[0-9]*"
          inputmode="numeric"
          @focus="Focused('NewPassOnlyNum', 'ack2', 'ChangePasswordForm');"
          id="ack2"
          v-model="NewPassOnlyNum"
          @keypress.enter.prevent="ChangePassword()"
        ></b-form-input>
      </b-form-group>

      <!-- <b-row>
        <b-col cols="10" md="6" lg="4" class="mx-auto mx-md-3 my-2">
          <Keyboard type="Numbers" theme="Light" />
        </b-col>
      </b-row>-->

      <div class="m-t-40 d-block border-top pt-3 pl-3">
        <b-btn type="submit" variant="success" size="lg">
          <i class="material-icons mifix">save</i>
          <span class="ml-1">Kaydet</span>
        </b-btn>
      </div>
    </form>
  </div>
</template>

<script>
import { mapState } from "vuex";
// import Keyboard from "../../Components/Keyboard";
import Services from "../../Service";
import Datetr from "@/Date";

export default {
  components: {
    // Keyboard
  },
  data() {
    return {
      OldPassword: "",
      NewPassword: ""
    };
  },
  computed: {
    ...mapState(["User", "ButtonSize"]),
    NewPassOnlyNum: {
      get: function() {
        return this.$store.state.NewPassword;
      },
      set: async function(n) {
        await this.$store.dispatch("SetData", {
          Key: "NewPassword",
          Value: n.replace(/[^0-9]/g, "")
        });
      }
    }
  },
  methods: {
    Date: (timestamp, format = "dd.mm.yyyy") => {
      return Datetr(timestamp, format);
    },
    Focused(Data, El, Form) {
      this.$store.dispatch("SetFocusedData", { Data, El, Form });
    },
    async ChangePassword() {
      // this.$store.dispatch("SetLog", {
      //   Key: "OldPassword",
      //   Value: this.OldPassword
      // });
      // this.$store.dispatch("SetLog", {
      //   Key: "NewPassOnlyNum",
      //   Value: this.NewPassOnlyNum
      // });

      if (this.OldPassword === "" || this.NewPassOnlyNum === "") {
        this.$store.dispatch("AddToastMessage", {
          Body: `${this.Date(
            new Date(),
            "HH:MM"
          )} - Eski ve yeni şifre alanlarını doldurunuz.`
        });

        return false;
      }

      this.$store.dispatch("ClearToastMessages");
      this.$store.dispatch("AddLoading", "ChangePassword");

      await Services.Nozich.Send(
        "ChangePassword",
        {
          OldPassword: this.OldPassword,
          NewPassword: this.NewPassOnlyNum
        },
        async Data => {
          this.$store.dispatch("RemoveLoading", "ChangePassword");

          if (Data.Status === "Success") {
            this.$store.dispatch("SetData", {
              Key: "AccessToken",
              Value: Data.AccessToken
            });

            let PasswordLength = String(this.NewPassOnlyNum).length;

            this.$store.dispatch("SetData", {
              Key: "PasswordLength",
              Value: PasswordLength
            });

            this.$store.dispatch("SetData", {
              Key: "AutomaticLogin",
              Value: PasswordLength
            });

            Services.Nozich.Console(
              `ChangePassword approved for User-${this.User.ID}`
            );

            this.$router.push("/");

            this.$store.dispatch("AddToastMessage", {
              Body: `${this.Date(new Date(), "HH:MM")} - Şifreniz Değişmiştir.`
            });
          } else {
            this.$store.dispatch("AddToastMessage", {
              Body: `${this.Date(
                new Date(),
                "HH:MM"
              )} - Şifre değiştirme işleminde hata meydana geldi.`
            });

            await this.$set(this, "OldPassword", "");
            await this.$set(this, "NewPassword", "");

            await this.$nextTick();
            await this.$forceUpdate();
          }
        }
      );
    }
  },
  async mounted() {
    this.$store.subscribe(async () => {
      await this.$nextTick();
      await this.$forceUpdate();
    });
  }
};
</script>
